export default "__VITE_PUBLIC_ASSET__f81c3400__"